<div class="pageTitle">
  Allocation
</div>
<div class="titleSpacerBelow">&nbsp;</div>

<div class="sectionContainer">

  <div class="sectionTitle">
    Probate Allocation by User
  </div>

  @if (loading) {
    <div class="loading-row">Loading...</div>
  } @else if (breakdown.length === 0) {
    <div class="empty-row">No users found.</div>
  } @else {
    <div class="table-scroll-wrapper">
      <table class="allocation-grid">
        <thead>
          <tr>
            <th class="select-header-cell">
              <mat-checkbox (change)="masterToggle()"
                            [checked]="isAllSelected()"
                            [indeterminate]="isSomeSelected()">
              </mat-checkbox>
            </th>
            <th class="name-header-cell">User</th>
            <th class="band-header-cell">1-3 Bequest Probates</th>
            <th class="band-header-cell">4-6 Bequest Probates</th>
            <th class="band-header-cell">7-9 Bequest Probates</th>
            <th class="band-header-cell">10+ Bequest Probates</th>
          </tr>
        </thead>
        <tbody>
          @for (row of breakdown; track row.userId) {
            <tr [class.no-config-row]="!row.hasAnyConfiguration">
              <td class="select-cell">
                <mat-checkbox (click)="$event.stopPropagation()"
                              (change)="$event ? selection.toggle(row) : null"
                              [checked]="selection.isSelected(row)">
                </mat-checkbox>
              </td>
              <td class="name-cell">
                {{ row.displayName }}
                @if (!row.hasAnyConfiguration) {
                  <span class="no-config-note">Not configured</span>
                }
              </td>
              <td class="band-cell">{{ formatBand(row.band123) }}</td>
              <td class="band-cell">{{ formatBand(row.band456) }}</td>
              <td class="band-cell">{{ formatBand(row.band789) }}</td>
              <td class="band-cell">{{ formatBand(row.band10Plus) }}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }

  <div class="allocateButtonContainer">
    <button mat-raised-button
            class="allocateButton"
            [disabled]="selection.selected.length === 0 || allocating"
            (click)="allocate()">
      {{ allocating ? 'Allocating...' : 'Allocate' }}
    </button>
  </div>

</div>
